module.exports = __webpack_public_path__ + "img/1@2x.38b88428.png";